<header>
  <div class="wrap">
    <div class="text">
      <h2 class="title">Debug information</h2>
    </div>
    <div class="header-actions">
      <button class="close" (click)="modalService.close()" title="{{ 'generic.close' | translate }}">
        <span class="icon-view-close" aria-hidden="true">
          <svg>
            <use xlink:href="assets/img/icons.svg#icon-view-close"></use>
          </svg>
        </span>
        <span>{{ 'generic.close' | translate }}</span>
      </button>
    </div>
  </div>
</header>
<div class="main">
  <div class="inner-content">
    
    <ng-casto-collapsible-section title="Global" [defaultOpen]="false">
      <strong>Version : </strong>{{ version }}
    </ng-casto-collapsible-section>

    <ng-container *ngIf="current.vendor">
      <ng-casto-collapsible-section title="Colleague">
        <strong>Name : </strong>{{ current.vendor.name }}<br />
        <strong>Given Name : </strong>{{ current.vendor.givenName }}<br />
        <strong>Family Name : </strong>{{ current.vendor.familyName }}<br />
        <strong>Email : </strong>{{ current.vendor.email }}<br />
        <strong>SAP ID : </strong>{{ current.vendor.sapId }}<br />
        <strong>OrgUnitText : </strong>{{ current.vendor.orgUnitText }}<br />
        <strong>Token : </strong>{{ subToken }}
        @if (hasToken) {
          <ng-casto-button class="primary" [label]="'Copier'" (click)="copyToken()"></ng-casto-button>
        }
      </ng-casto-collapsible-section>

      <ng-casto-collapsible-section title="Store" [defaultOpen]="false">
        <strong>Magasin : </strong>{{ current.vendor.store.name }}<br />
        <strong>SAP Store ID : </strong>{{ current.vendor.store.SAPStoreId }}<br />
        <strong>Legacy Store ID : </strong>{{ current.vendor.store.legacyStoreId }}<br />
        <strong>Switch Date : </strong>{{ current.vendor.store.switchDate }}<br />
        <strong>.Com+ URL : </strong>{{ current.vendor.store.dotComPlusURL }}<br />
        <strong>Legacy SBO URL : </strong>{{ current.vendor.store.legacySboURL }}<br />
        <strong>Catalogue : </strong>{{ current.vendor.store.catalogs }}
      </ng-casto-collapsible-section>

      <ng-container *ngIf="customer.isLogged">
        <ng-casto-collapsible-section title="Current selected customer">
          <strong>Full name : </strong>{{ customer.fullName }}<br />
          <strong>ID : </strong>{{ customer.userDatas?.id }}<br />
          <strong>Token : </strong>{{ customer.token }}<br />
        </ng-casto-collapsible-section>
      </ng-container>
    </ng-container>

    <ng-casto-collapsible-section title="Debug">
      <ngx-json-viewer [json]="debugObj" [expanded]="false"></ngx-json-viewer>
    </ng-casto-collapsible-section>

  </div>
</div>
